// test1880
(1880 && 0);
